import { __makeTemplateObject } from 'tslib';
import React__default from 'react';
import styled from 'styled-components';
import { Box } from '../box/Box.js';
import { Currency } from '../currency/Currency.js';
import { Text } from '../text/Text.js';
import ProductRRP from './ProductRRP.js';

var Price = /*#__PURE__*/styled(Text).withConfig({
  displayName: "ProductPrice__Price",
  componentId: "sc-1tsspjx-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  sup {\n    font-size: 0.6em;\n    position: relative;\n    top: 0.15em;\n  }\n"], ["\n  sup {\n    font-size: 0.6em;\n    position: relative;\n    top: 0.15em;\n  }\n"])));
var priceFontSizes = {
  sm: "1em",
  md: "1.25em",
  lg: "1.75em"
};
var getPriceFontSize = function (size) {
  if (Array.isArray(size)) {
    return size.map(function (s) {
      return priceFontSizes[s];
    });
  }
  return priceFontSizes[size];
};
var ProductPrice = function (_a) {
  var _b = _a.size,
    size = _b === void 0 ? "sm" : _b,
    price = _a.price,
    rrp = _a.rrp;
  return React__default.createElement(Box, {
    display: "inline-flex",
    alignItems: "center",
    fontSize: getPriceFontSize(size)
  }, rrp && rrp > price && React__default.createElement(ProductRRP, {
    amount: rrp
  }), React__default.createElement(Price, {
    fontSize: "inherit",
    fontFamily: "heading",
    letterSpacing: "tight",
    color: "text.heading",
    fontWeight: "600"
  }, React__default.createElement(Currency, {
    amount: price,
    includeFraction: true
  })));
};
var templateObject_1;

export { ProductPrice };
//# sourceMappingURL=ProductPrice.js.map
